import { inject } from '@angular/core';
import { CodetableService } from './codetable.service';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

export const codetableResolver = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  return inject(CodetableService).resolveCodetableEntries();
};
